import { useQuery } from '@tanstack/react-query';
import { dataExportGetFarmerData } from '../../api';
import { DataTabs } from './DataTabs';

function formatSize(bytes?: number) {
	if (!bytes || bytes <= 0) {
		return null;
	}
	if (bytes >= 1024 * 1024 * 1024) {
		return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
	}
	if (bytes >= 1024 * 1024) {
		return `${(bytes / (1024 * 1024)).toFixed(0)} MB`;
	}
	return `${(bytes / 1024).toFixed(0)} KB`;
}

export function FarmerDataPage() {
	const { data: files = [], isLoading, isError, refetch } = useQuery({
		queryKey: ['farmer-data'],
		queryFn: () => dataExportGetFarmerData(),
	});

	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold text-gray-900">Farmer Data</h1>

			<DataTabs />

			<div className="bg-white rounded-lg shadow p-4">
				<p className="text-xs text-gray-500 mb-4">
					Data from farmers, provided by SEGES.
				</p>

			{isLoading ? (
				<p className="text-xs text-gray-400">Loading…</p>
			) : isError ? (
				<div className="flex items-center gap-4">
					<p className="text-xs text-red-500">Failed to load farmer data.</p>
					<button
						type="button"
						onClick={() => refetch()}
						className="py-1.5 px-3 bg-smartfield text-white rounded-lg hover:bg-smartfield/90 transition-colors font-medium text-xs whitespace-nowrap"
					>
						Retry
					</button>
				</div>
			) : files.length === 0 ? (
					<p className="text-xs text-gray-400">No farmer data available yet.</p>
				) : (
					<div className="divide-y divide-gray-100">
						{files.map(f => {
							const displayName = (f.fileName ?? '').replace(/\.zip$/i, '');
							const size = formatSize(f.sizeBytes);
							const updated = f.lastModified ? `Updated ${new Date(f.lastModified).toLocaleDateString()}` : null;
							return (
								<div key={f.fileName ?? f.url} className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0">
									<div className="min-w-0">
										<p className="text-sm font-medium text-gray-900 truncate">{displayName}</p>
										{(size || updated) && (
											<p className="text-xs text-gray-400">{[size, updated].filter(Boolean).join(' · ')}</p>
										)}
									</div>
									<a
										href={f.url}
										download
										className="py-2 px-4 bg-smartfield text-white rounded-lg hover:bg-smartfield/90 transition-colors font-medium text-sm text-center whitespace-nowrap"
									>
										Download
									</a>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
}
